import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/back_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-b1c13228"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-wrap" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#/",
      class: "back"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ])
  ])
], -1))
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "HIRAIDAI TOUR 2024", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("LOCALS ONLY MEMBER限定 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("SPACIAL COUPON")
  ])
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "coupon-img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "text1"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 「HIRAIDAI TOUR 2024」の ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("会場グッズ購入時にご利用いただけます。 ")
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "text1"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 「HIRAIDAI TOUR 2024」の ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("会場グッズ購入時にご利用いただけます ")
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" COUPONの利用手続きは一度行うと元に戻せません。係員の指示に従って操作してください。 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" ご利用ありがとうございます。 ")
const _hoisted_21 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "読み込み中...", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "bottom" }
const _hoisted_25 = { class: "inner" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-warning" }, "ご利用上の注意", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "point-warning" }, " ・本クーポンは”LOCALS ONLY”の有料会員のみご利用いただけます。 ", -1))
const _hoisted_28 = {
  key: 0,
  class: "point-warning"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "point-warning" }, " ・一度使用済となると元に戻せません、予めご了承ください。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CouponStepBNoticeInstructionsBeforeUse = _resolveComponent("CouponStepBNoticeInstructionsBeforeUse")!
  const _component_CouponStepCNoticeWithConfirmUse = _resolveComponent("CouponStepCNoticeWithConfirmUse")!
  const _component_CouponStepANoticeNonMember = _resolveComponent("CouponStepANoticeNonMember")!
  const _component_CouponStepDMessageThanks = _resolveComponent("CouponStepDMessageThanks")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["coupon", { 'no-header': !_ctx.showHeader }])
  }, [
    _hoisted_1,
    _createElementVNode("main", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_ctx.isAppLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.isCouponStepDMemberCouponUsed)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.getUsingCouponImage
                  }, null, 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.getUsedCouponImage
                  }, null, 8, _hoisted_8))
            ]),
            (!_ctx.isCouponStepDMemberCouponUsed && _ctx.coupon_type === 'drink')
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _hoisted_13))
              : _createCommentVNode("", true),
            (!_ctx.isCouponStepDMemberCouponUsed && _ctx.coupon_type === 'goods')
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _hoisted_18))
              : _createCommentVNode("", true),
            (_ctx.isCouponStepBMemberWaitingOnCouponUse)
              ? (_openBlock(), _createBlock(_component_CouponStepBNoticeInstructionsBeforeUse, { key: 2 }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isCouponStepCMemberWaitingOnPressUseButton)
              ? (_openBlock(), _createBlock(_component_CouponStepCNoticeWithConfirmUse, {
                  key: 3,
                  checked: _ctx.isConfirmCheckboxChecked,
                  onCheck: _ctx.toggleConfirmCheckbox
                }, null, 8, ["checked", "onCheck"]))
              : _createCommentVNode("", true),
            (!_ctx.isCouponStepDMemberCouponUsed)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 4,
                  class: _normalizeClass(["use", {
            active:
              _ctx.isCouponStepBMemberWaitingOnCouponUse ||
              (_ctx.isCouponStepCMemberWaitingOnPressUseButton &&
                _ctx.isConfirmCheckboxChecked),
          }]),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickUseButton && _ctx.clickUseButton(...args)))
                }, _toDisplayString(_ctx.isCouponStepCMemberWaitingOnPressUseButton
              ? 'COUPONを使用済にする'
              : 'COUPONを利用する >>'), 3))
              : _createCommentVNode("", true),
            (_ctx.isCouponStepANonMember)
              ? (_openBlock(), _createBlock(_component_CouponStepANoticeNonMember, { key: 5 }))
              : _createCommentVNode("", true),
            (_ctx.isCouponStepDMemberCouponUsed)
              ? (_openBlock(), _createBlock(_component_CouponStepDMessageThanks, { key: 6 }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
    ]),
    _createElementVNode("main", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", null, [
          _hoisted_27,
          (_ctx.coupon_type === 'drink')
            ? (_openBlock(), _createElementBlock("p", _hoisted_28, " ・本クーポンはおひとり様1回限りご利用いただけます。 "))
            : _createCommentVNode("", true),
          _hoisted_29
        ])
      ])
    ])
  ], 2))
}